import { render, staticRenderFns } from "./EnumAsText.vue?vue&type=template&id=105c534f&"
import script from "./EnumAsText.vue?vue&type=script&lang=js&"
export * from "./EnumAsText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports